import React, { useState, useContext } from 'react';
import { Send } from 'lucide-react';
import axios from 'axios';
import AppContext from '../../../../../context/AppContext';

const BidForm = ({ jobId, onSubmit, refreshJobs }) => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [message, setMessage] = useState('');
  const [bidAmount, setBidAmount] = useState('');
  const [loading, setLoading] = useState(false);

  // place bid
  const placebid = () => {

    setLoading(true);

    const formData = new FormData();

    formData.append("message", message);
    formData.append("bidAmount", bidAmount);
    formData.append("whpostjob_id", jobId);

    const authToken = localStorage.getItem("authToken");

    axios.post(`${baseUrl}/worker/placebid`, formData, {

      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "multipart/form-data"
      }

    })

      .then((response) => {
        console.log(response.data);
        setLoading(false);

        refreshJobs(); // ✅ yahan call karo
      })

      .catch((err) => {

        setLoading(false);

        console.log(err.response?.data || err.message);

        // alert("Server Error");

      });

  }
};

export default BidForm;